import {SearchOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import DebouncingInput from '../../elements/DebouncingInput';
import {useSelector} from "react-redux";


const SearchFilterTable = () => {
    const searchInput = useRef(null);
    const filter = useSelector((state) => state.TableRedux.filter);

    const getColumnSearchProps = (placeholder = 'جستجو...', initialValue, callbackData,dataIndex) => ({
        filterDropdown: (/*{setSelectedKeys, selectedKeys, confirm,  clearFilters}*/) => (<div
            style={{
                padding: 8, width: '180px'
            }}
        >
            <DebouncingInput allowClear ref={searchInput} defaultValue={initialValue}
                             onChange={(value) => {
                                 callbackData(value)
                             }}
                             placeholder={placeholder}/>


        </div>), filterIcon: (filtered) => (<SearchOutlined
            style={{
                color: filter[dataIndex] ? 'blue' : undefined,
            }}
        />), onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
    });


    return [getColumnSearchProps];
};

export default SearchFilterTable;